export default {"src":"/_next/static/media/circleInfoUiRed_24.a3962184.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};